import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { compose } from 'redux';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';
import { getMarketDerivatives } from 'builder/utils';
import { featureKeys } from 'services/FeatureFlagService';

import PublishAddModal from '../PublicationModal/PublishAdd';
import PublishOutputType from '../PublicationModal/PublishOutputType';
import PublishMarketSelect from '../PublicationModal/PublishMarketSelect';

function PublishPostActivitySelectFlow({ onDismiss, setPublicationOutputType, setPublicationMarket, outputType, addToPublication, activity, getFeatureFlagValue }) {
  const marketsEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_MARKET_DERIVATIVES);
  const [currentPostActivitySelectStep, setCurrentPostActivitySelectStep] = useState(0);
  const [marketDerivatives, setMarketDerivatives] = useState(null);

  useEffect(() => {
    const getMarkets = async () => {
      const marketDerivatives = await getMarketDerivatives(activity.activityId);
      setMarketDerivatives(marketDerivatives);
    };
    if (marketsEnabled) {
      getMarkets();
    }
  });

  const updatePublicationOutputType = (type) => {
    setPublicationOutputType(type);
    setCurrentPostActivitySelectStep(currentPostActivitySelectStep + 1);
  };

  const updatePublicationMarket = (market) => {
    setPublicationMarket(market);
    setCurrentPostActivitySelectStep(currentPostActivitySelectStep + 1);
  };

  const handleDismiss = () => {
    setCurrentPostActivitySelectStep(0);
    onDismiss();
  };

  const buildPostActivitySteps = () => {
    const steps = [];
    const outputTypeComponent = (
      <PublishOutputType
        onDismiss={handleDismiss}
        setPublicationOutputType={(type) => updatePublicationOutputType(type)}
      />
    );
    const marketDerivativePicker = (
      <PublishMarketSelect
        onDismiss={handleDismiss}
        setSelectedMarket={(market) => updatePublicationMarket(market)}
        markets={marketDerivatives}
      />
    );
    const publishAddComponent = (
      <PublishAddModal
        onDismiss={handleDismiss}
        outputType={outputType}
        addToPublication={addToPublication}
        activity={activity}
      />
    );
    steps.push(outputTypeComponent);
    if (marketsEnabled && marketDerivatives?.length) {
      steps.push(marketDerivativePicker);
    }
    steps.push(publishAddComponent);
    return steps;
  };

  const postActivitySelectSteps = buildPostActivitySteps();

  return (
    <div>
      {postActivitySelectSteps[currentPostActivitySelectStep]}
    </div>
  );
}

PublishPostActivitySelectFlow.propTypes = {
  onDismiss: PropTypes.func,
  onAddPublicationOutputType: PropTypes.func,
};
const flagNames = [
  featureKeys.WORKSPACE_MARKET_DERIVATIVES,
];

export default compose(withTheme, enhanceWithFeatureFlagSubscription)(PublishPostActivitySelectFlow, flagNames);
